import { useAuth } from '../hooks/use-auth'

export function ImpersonationBanner() {
  const { isImpersonating, user, stopImpersonation } = useAuth()

  if (!isImpersonating || !user) return null

  return (
    <div
      role="alert"
      style={{
        padding: '0.6rem 1rem',
        background: '#fde8e8',
        borderBottom: '1px solid #fca5a5',
        color: '#991b1b',
        fontSize: '13px',
        fontWeight: 500,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '1rem',
      }}
    >
      <span>
        Impersonating: <strong>{user.email}</strong> ({user.role})
      </span>
      <button
        type="button"
        onClick={stopImpersonation}
        style={{
          background: '#991b1b',
          color: '#fff',
          border: 'none',
          borderRadius: '3px',
          cursor: 'pointer',
          fontSize: '12px',
          fontWeight: 600,
          padding: '0.25rem 0.75rem',
          flexShrink: 0,
        }}
      >
        Stop Impersonation
      </button>
    </div>
  )
}
